import moduleIntegrityCheck from "~components/shared/module/Module.integrity";
import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    const messages: IntegrityStatus = moduleIntegrityCheck(props);

    if (!props.html) messages.push("Missing html field");

    return messages;
}
